import { IAbUseExperiment } from '../types/abUseExperiments';

export const NEW_DEAL_RENT_OFFER_INFO_BLOCK = 'new_deal_rent_offer_info_block_web';

export const isNewDealRentOfferInfoBlock = (experiments: IAbUseExperiment[]): boolean => {
  const experiment = experiments.find(exp => exp.experimentName === NEW_DEAL_RENT_OFFER_INFO_BLOCK);

  return Boolean(experiment && experiment.groupName === 'enabled');
};
